// 대화 기록(계약 §13, 대표 전용) — 공유 클라이언트(X-Admin-Id)를 쓴다
import { http, data } from "../../inquiry/v6Api";

export const listSessions = (params) => data(http.get("/chat-history/sessions/v6", { params }));
export const countSessions = (params) => data(http.get("/chat-history/sessions/count/v6", { params }));
export const wordcloud = (params, topN) => data(http.get("/chat-history/wordcloud/v6", { params: { ...params, top_n: topN } }));
export const getSessionDetail = (id) => data(http.get(`/chat-history/sessions/${id}/detail`));
export const registerInquiry = (id) => data(http.post(`/chat-history/sessions/${id}/inquiry`));
export const exportLogs = (limit = 50) => data(http.get("/chat-history/export-logs", { params: { kind: "conversation", limit } }));
export const quickCategories = () => data(http.get("/system/quick-categories"));

function readBlob(b) {
    if (typeof b.text === "function") return b.text();
    return new Promise((resolve, reject) => {
        const r = new FileReader();
        r.onload = () => resolve(r.result);
        r.onerror = reject;
        r.readAsText(b);
    });
}

function fileName(headers) {
    const cd = headers?.["content-disposition"] || "";
    const m = /filename\*=UTF-8''([^;]+)/i.exec(cd) || /filename="?([^";]+)"?/i.exec(cd);
    try { return m ? decodeURIComponent(m[1]) : null; } catch { return m[1]; }
}

// 머리말(X-Admin-Id)이 필요해 링크 대신 blob 으로 받는다. 오류 본문도 blob 이라 JSON 으로 풀어 둔다
export async function exportCsv(params) {
    try {
        const r = await http.get("/chat-history/export", { params, responseType: "blob" });
        return { blob: r.data, name: fileName(r.headers) };
    } catch (e) {
        const b = e?.response?.data;
        if (typeof Blob !== "undefined" && b instanceof Blob) {
            try { e.response.data = JSON.parse(await readBlob(b)); } catch { /* 그대로 둔다 */ }
        }
        throw e;
    }
}
